import React from 'react';
import moment from 'moment';
import TableHeader from '../TableHeader';
import axios from 'axios';
import {
  CSRF_TOKEN,
  requestCallback
} from '../../lib/helpers';

const UnprocessedExchangeHistoryList = ({
  giftExchangeHistories = [],
  all = false,
  total = 0
}) => {
  const handleReprocess = (exchangeHistory) => {
    const confirmation = window.confirm(`Are you sure you want to reprocess Exchange history id ${exchangeHistory.id}?`)
    if (confirmation) {
      requestCallback(axios.post(`/${gon.currentProvider}/api/gifting/exchange_histories/reprocess`, {
        id: exchangeHistory.id,
        user_id: exchangeHistory.userId,
        authenticity_token: CSRF_TOKEN,
      }))
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Unprocessed Gift Exchange History list</h2>
          {total > 0 && <p className='MainHeader__left__p'>Total {total.toLocaleString()}</p>}
        </div>
      </div>

      <div className='Table__wrapper'>
        <div className='Table Table--gift-exchange-histories-list'>
          {(() => {
            const columnHeaders = [
              {
                label: 'ID'
              },
              {
                label: 'User ID'
              },
              {
                label: 'Gift Reward ID'
              },
              {
                label: 'Quantity'
              },
              {
                label: 'Rewarded Amount'
              },
              {
                label: 'UUID'
              },
              {
                label: 'Status'
              },
              {
                label: 'Create At'
              },
              {
                label: 'Manage'
              },
              {
                label: 'Update At'
              }
            ]

            return (
              <div className='Table__row'>
                {columnHeaders.map((header, key) => (
                  <TableHeader
                    key={key}
                    header={header}
                  />
                ))}
              </div>
            )
          })()}

          {giftExchangeHistories.map((exchangeHistory) => (
            <div
              className='Table__row'
              key={`${exchangeHistory.id}`}
              data-x={exchangeHistory}
            >
              <div className='Table__col'>
                {exchangeHistory.id}
              </div>
              <div className='Table__col'>
                <a
                  className='Table__a'
                  href={`/${gon.currentProvider}/users/${exchangeHistory.userId}`}
                >
                  {exchangeHistory.userId}
                </a>
              </div>
              <div className='Table__col'>
                {exchangeHistory.giftRewardId}
              </div>
              <div className='Table__col'>
                {exchangeHistory.quantity}
              </div>
              <div className='Table__col'>
                {exchangeHistory.rewardedAmount}
              </div>
              <div className='Table__col'>
                {exchangeHistory.uuid}
              </div>
              <div className='Table__col'>
                {exchangeHistory.status}
              </div>
              <div
                className='Table__col'
                dangerouslySetInnerHTML={
                  {
                    __html: exchangeHistory.createdAt !== null ?
                      moment(exchangeHistory.createdAt).format('YYYY-MM-DD<br />HH:mm')
                    :
                      'N/A'
                  }
                }
              />
              <div
                className='Table__col'
                dangerouslySetInnerHTML={
                  {
                    __html: exchangeHistory.updatedAt !== null ?
                      moment(exchangeHistory.updatedAt).format('YYYY-MM-DD<br />HH:mm')
                    :
                      'N/A'
                  }
                }
              />
              <div className='Table__col'>
                <div className='Table__controls'>
                  <a
                    className='DotTooltip__link'
                    onClick={() => handleReprocess(exchangeHistory)}
                  >
                    Reprocess
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        {all && (
          <a
            className='Table__view-all'
            href={`/${gon.currentProvider}/gifting/exchange_histories/unprocessed`}
            >
            View all
          </a>
        )}
      </div>
    </React.Fragment>
  );
}

export default UnprocessedExchangeHistoryList
